import React from 'react';
import Input from '../../Components/Form/Input';
import Button from '../../Components/Form/Button';
import useForm from '../../Hooks/useForm';
import useFetch from '../../Hooks/useFetch';
import Head from '../Helper/Head';
import Error from '../../Components/Helper/Error';
import { PASSWORD_LOST } from '../../api';
const LoginPasswordLost = () => {
  const login = useForm();
  const {data, loading, error, request} = useFetch();
  async function handleSubmit(event){
    event.preventDefault();
    
      const {url, options} = PASSWORD_LOST({
        login: login.value,
        url: window.location.href.replace('forgot', 'reset')
      })
    
    const {json} = await request(url, options);
    console.log(json);
  }
  return (
    <section className="animeLeft">
      <Head title="Recuperar senha"/>
      <h1 className="title">Perdeu a senha?</h1>
      {data ? (
        <p style={{color: '#4c1'}}>{data}</p>
      ): (
        <form onSubmit={handleSubmit}>
        <Input label="Email / Usuário" type="text" name="login" {...login}/>
        {loading ? <Button disabled>Enviando...</Button> : <Button>Enviar Email</Button>}
        </form>
      )}
      <Error error={error}/>
    </section>
  )
}

export default LoginPasswordLost
